export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('Nuxt Hook: "vue:error" -', error)
    }
  })
})
